import React, { useContext, useEffect, useState } from "react";
import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";
import Testimonials from "../Testimonial";


function BalanceSheetPL() {

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",

      }));
    }
  }, []);


  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };


  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_category: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);

  const service = services.find(s => s.service_id === 52);

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }

    // Email validation
    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    // Phone number validation
    // if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
    //    newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    // }

    if (!newData.user_contact.trim()) {
      newErrors.user_contact = 'number is required.';
    } else if (!/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    // Category validation
    if (!newData.user_category) {
      newErrors.user_category = 'Please select a category.';
    }

    // City validation
    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };



  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();
    // ✅ Check if user is logged in
    // if (!token) {
    //   alert("Please log in to continue.");
    //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //   navigate('/login'); // 👈 Use this if you're using React Router
    //   return;
    // }
    if (!validateForm()) return;

    localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

  };

  const faqs = [
  {
    question: "What are the components of a Balance Sheet?",
    answer: "Current & Long-Term Assets, Current & Long-Term Liabilities, Shareholders' Equity, Account Balances, and Depreciation or Amortization."
  },
  {
    question: "Why might a Balance Sheet not balance?",
    answer: "Common reasons include: currency errors, inventory issues, missing data, incorrect entries, or miscalculated equity and depreciation."
  },
  {
    question: "What falls under Current Assets?",
    answer: "Cash, Inventory, Accounts Receivable, and Short-term Marketable Securities."
  },
  {
    question: "What are Non-Current Assets?",
    answer: "Property, Long-term Investments, Goodwill, and Intangible Assets."
  },
  {
    question: "Where are salaries recorded?",
    answer: "Admin salaries = fixed expenses. Manufacturing wages = cost of goods sold."
  },
  {
    question: "Balance Sheet vs. P&L Statement?",
    answer: "Balance Sheet shows financial position at a point in time; P&L shows income and expenses over time."
  },
  {
    question: "Profit & Loss vs. Income Statement?",
    answer: "They're the same—just different names."
  },
  {
    question: "What is a Year-to-Date P&L?",
    answer: "It shows profits from the start of the fiscal year to date."
  },
  {
    question: "Which is prepared first—P&L or Balance Sheet?",
    answer: "P&L comes first; its result feeds into the Balance Sheet."
  },
  {
    question: "What does a small business P&L include?",
    answer: "Revenue, COGS, Gross Profit, Expenses, Net Profit or Loss."
  }
];


  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>
                <h1 className="sk-text-color">Balance Sheet Preparation & P&L | Small Business Balance Sheet | Prepare your Financial Report Online</h1>
                <p className="pdrl-text">Get Registration for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                <p className="pd-text">Let the expert team at DM2Legal take care of your Balance Sheet and Profit & Loss statements, so you can stay focused on your business goals without the stress of managing cash flow.</p>

                {/* <div className="banner">
                  <img src="assets/icons/banner.svg" alt="" srcset="" />
                </div> */}
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now </h3>
                  <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Final Price, No Hidden Costs)</span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label> {errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label> {errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                        <div className="col-12">
                          <label for="" className="dropdown-text">Category<span className="red">*</span></label> {errors.user_category && <p className="error-text">{errors.user_category}</p>}
                          <div className="niceSelect">
                            <select className="wide" onChange={(e) => setNewData({ ...newData, user_category: e.target.value })} value={newData.user_category}>
                              <option className="formop" data-display="Select Category...">Select Category...</option>
                              <option value="Sole Proprietorship / Individual">Sole Proprietorship / Individual</option>
                              <option value="Partnership / LLP">Partnership / LLP</option>
                              <option value="Private limited / Public limited / One person company">Private limited / Public limited / One person company</option>
                              <option value="HUF">HUF</option>
                              <option value="Society / Trust / Club">Society / Trust / Club</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <p className="pd-text">Maintaining accurate Balance Sheets and Profit & Loss (P&L) statements is crucial for any business. These financial records offer a clear picture of your company's operations — covering income, sales, expenses, and overall profitability for a specific period. Let DM2Legal take the hassle out of managing them.

                A Balance Sheet provides a snapshot of your company’s financial health, showing assets, liabilities, and equity, including owner or shareholder investments. It works alongside your P&L and Cash Flow statements, offering a comprehensive view of your business performance and financial flow.

                Your P&L statement (or income statement) breaks down revenue and expenses, while the Cash Flow statement reveals how money enters and exits your business. Together, these documents help you understand the full story of your financial journey.

                It's smart to review these reports monthly to ensure your business is on track — or to spot early signs that a strategy shift might be needed. But with busy schedules and limited resources, many business owners overlook this. That’s where DM2Legal comes in. We simplify Balance Sheet and P&L preparation, so you can stay focused on growth while we handle the numbers.</p>

            </div>
          </div>
          <div className="space20"></div>

        </div>
      </div>



      <div className="service-binifits9 bg-white" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/new/Balance-Sheet-Preparation-&-P&L.png" />
              </div>
              <div className="space20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="space20 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">Essentials of preparing Balance Sheet & P&L for Small Business </h2>
                <div className="space20"></div>
                <p className="pd-text">Small businesses often face financial constraints, making it essential to keep a close watch on their financial health. A balance sheet provides a clear snapshot of a company’s financial standing, allowing entrepreneurs to evaluate their liquidity, solvency, and overall business performance. With the insights gained from a well-prepared balance sheet, small business owners can make strategic decisions, appeal to investors, and drive their ventures toward long-term success.</p>
                <div className="space20"></div>
                <p className="pd-text">At DM2Legal, we view the balance sheet not just as a financial statement, but as a critical decision-making tool that empowers entrepreneurs. It helps them gain clarity, attract potential backers, and confidently navigate the challenges of running a business.</p>
                <div className="space20"></div>
                <p className="pd-text">
                  Think of the balance sheet as a financial compass—guiding small businesses through the ups and downs of entrepreneurship. Its value lies in several core areas that play a vital role in a company’s growth and stability:</p>


              </div>
            </div>

            <div className="col-lg-8">
              <div className="hadding7">
                <div className="space20"></div>

                <div className="contact6-list">
                  <ul>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Assessment of Financial Health
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Decision-Making Support
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Attraction of Investors and Lenders
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Stakeholder Communication
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Strategic Planning
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Compliance and Regulation
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3">
              <img src="assets/img/images/Documents-Required-for-IEC-Registration.png" alt="" />
            </div>
          </div>
          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <h2 className="text-center">Components of a Basic Balance Sheet</h2>
              </div>
            </div>
            <div className="space20"></div>
            <p className="pd-text">A basic balance sheet is a fundamental tool in financial reporting, offering a snapshot of a company’s financial position at a specific point in time. At DM2Legal, we outline the core components that make up this crucial document:</p>

            <div className="col-lg-8">

              <div className="hadding7">

                <div className="space20"></div>
                <div className="contact6-list">
                  <ul>
                    <li className="font-f-7 step-font-size">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Assets
                      <p className="pd-text">Assets represent everything the company owns or controls that has economic value. This includes both tangible items like cash, equipment, and inventory, as well as intangible assets such as trademarks, patents, or goodwill.</p>
                    </li>
                    <hr />
                    <li className="font-f-7 step-font-size">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Liabilities
                      <p className="pd-text">Liabilities are the company’s existing financial commitments to external parties. These may include loans, accounts payable, tax obligations, and other outstanding expenses the company is responsible for.</p>
                    </li>
                    <hr />
                    <li className="font-f-7 step-font-size">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Shareholders' Equity
                      <p className="pd-text">Also known as net worth, shareholders' equity is calculated by subtracting total liabilities from total assets. It represents the residual interest or ownership stake held by the company’s shareholders.</p>
                    </li>
                    <hr />


                  </ul>

                  <p className="pd-text">By clearly presenting these elements, a balance sheet offers valuable insights into a company’s financial well-being—helping business owners, investors, and stakeholders make informed decisions and plan effectively for the future.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="space30"></div>
              <img src="assets/img/images/Online-IEC-Code-Registration-Step-by-Step-Guide.png" alt="" />
            </div>
          </div>
          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">

                <h2 className="text-center">
                  What is the Balance Sheet Equation between Assets and Liabilities?</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="space20"></div>
              <p className="pd-text">At DM2Legal, we emphasize the importance of the balance sheet equation, also known as the accounting equation, which is a cornerstone of financial accounting. This fundamental principle states that a company’s assets must always equal the sum of its liabilities and shareholders’ equity. In simpler terms, everything a business owns is financed either through debts (liabilities) or the owner’s capital (equity).
              </p>
              <div className="space20"></div>
              <p className="pd-text">This equation is central to understanding a company’s financial standing. By ensuring that assets are in balance with liabilities and equity, businesses can gain clear insights into their liquidity, solvency, and overall financial health. Maintaining this balance is essential not only for internal decision-making but also for building trust with investors, creditors, and other stakeholders.</p>
              <div className="space20"></div>
              <p className="pd-text">Moreover, the balance sheet equation acts as a framework for accurate financial reporting and analysis. It enables companies to monitor performance over time, detect issues early, and make well-informed strategic decisions. A solid grasp of this concept is key to interpreting financial statements and assessing a company’s stability and long-term viability.</p>
            </div>

          </div>
          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">Understanding Shareholders Equity</h2>
                <div className="space20"></div>
                <p className="pd-text">At DM2Legal, we recognize that shareholders' equity is a cornerstone of a company’s financial structure. Found on the balance sheet, it represents the owners’ claim on the company’s assets after all liabilities have been accounted for. This section typically includes components like share capital, retained earnings, and additional paid-in capital. Shareholders' equity serves as a vital measure of a company's financial strength and long-term sustainability. For investors, analysts, and business leaders, it provides valuable insight into the company's value and growth potential.</p>
                <div className="space20"></div>

                <p className="pd-text">
                  How Shareholders’ Equity Is Reflected on the Balance Sheet:</p>


              </div>
            </div>

            <div className="col-lg-8">
              <div className="hadding7">
                <div className="space20"></div>

                <div className="contact6-list">
                  <ul>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Identification of Shareholders' Equity
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Inclusion in the Equity Section
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Calculation of Total Equity
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Impact on the Balance Sheet Equation
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Implications for Financial Analysis
                    </li>

                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3">
              <img src="assets/img/images/Documents-Required-for-IEC-Registration.png" alt="" />
            </div>
          </div>


          <div className="space20"></div>
        </div>
      </div>



      <div className="bg-white">

        <div className="container">


          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">Benefits to prepare Balance Sheet Preparation & P&L Online</h2>
              </div>
            </div>
            <div className="space30"></div>
          </div>
          <div className="row">
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-9.png" alt="" />
                </div>
                <h3>
                  Prompt Balance Sheet Report</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-10.png" alt="" />
                </div>
                <h3>Up to date Financial Statement</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-16.png" alt="" />
                </div>
                <h3>Updated Accounting Software</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-12.png" alt="" />
                </div>
                <h3>Determine Risk & Return</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-13.png" alt="" />
                </div>
                <h3>Increased Productivity</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-14.png" alt="" />
                </div>
                <h3>Boost Efficiency</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-15.png" alt="" />
                </div>
                <h3>Streamlined Process</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-11.png" alt="" />
                </div>
                <h3>Managed Liquidity</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-16.png" alt="" />
                </div>
                <h3>Controlled Solvency</h3>
              </div>
            </div>
            {/* <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-14.png" alt="" />
                </div>
                <h3>Secures Finances</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-10.png" alt="" />
                </div>
                <h3>Tax Analyzation</h3>
              </div>
            </div>

            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-12.png" alt="" />
                </div>
                <h3>Tracks Business Performance</h3>
              </div>
            </div> */}
          </div>



        </div>
      </div>


      <div className="service-binifits9 sp0" id="service2">
        <div className="container work8">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2>Registration Process to get your Balance Sheet and P&L prepared by DM2Legal</h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li> <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>At DM2Legal, our expert CAs thoroughly review your documents to ensure accuracy and a smooth process.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Our top-tier professionals are available to assist you with all documentation and licensing requirements.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Once your documents are reviewed, a dedicated expert will proceed with the preparation of your Balance Sheet and Profit & Loss (P&L) statement.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Our CAs accurately prepare your Balance Sheet and P&L, reflecting all financial details as of your reporting date.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>Please wait to hear from one of our experts, who will confirm once your Balance Sheet and P&L statement have been successfully prepared.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>
      <div className="bg-white">

        <div className="container ">

          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FAQs on Import Export License </h2>
                    <div className="space20"></div>


                    <div id="general">


                  
                   {faqs.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}







                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Testimonials />



      <div className="sp2 last-section bg-white">
        <div className="container">
               <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate">Why Choose Us?</h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                           <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                           <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                           <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                           <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                           <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
      </div>

      <div className="space40 bg-white"></div>


      <WhatsAppScrollButton />
      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default BalanceSheetPL;